import React, { useEffect, useState } from 'react';
import CardTool from '../CardTool';

const CardToolList = () => {
  const [tools, setTools] = useState([]);
  const [loading, setLoading] = useState(true);

const DATA_URL = 'https://gsx2json.com/api?id=14VrFKDzz44LbD6TVifFfncD2ahhZCPWMGzBPNp7Nh8w&sheet=Tools';


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(DATA_URL);
        const data = await response.json();

        const toolsFromSheet = data.rows.map((item) => ({
          toolName: item.toolName,
          description: item.description,
          url: item.url,
        }));

        setTools(toolsFromSheet);
      } catch (error) {
        console.error('Erro ao carregar ferramentas:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <p>Carregando ferramentas...</p>;

  return (
    <div className="card-tool-row">
      {tools.map((tool, index) => (
        <CardTool
          key={index}
          toolName={tool.toolName}
          description={tool.description}
          url={tool.url}
        />
      ))}
    </div>
  );
};

export default CardToolList;
